{
  "versi": 1,
  "mapel": "bahasa-indonesia",
  "keterangan": "Soal pengembangan Teks Informasi (orisinal), dengan alasan setiap pilihan dan bukti dari teks.",
  "bacaan": [
    {
      "id": "pi-siklus-air",
      "jenis": "Teks Informasi",
      "judul": "Perjalanan Air yang Tidak Pernah Berhenti",
      "teks": "Air yang kita minum hari ini mungkin pernah menjadi bagian dari awan, hujan, atau bahkan lautan yang jauh. Hal itu terjadi karena air di bumi terus bergerak dan berpindah tempat dalam sebuah perjalanan yang disebut siklus air. Siklus air adalah peredaran air dari bumi ke udara, lalu kembali lagi ke bumi secara terus-menerus.\n\nSiklus air dimulai ketika panas matahari memanaskan air di laut, sungai, dan danau. Air yang terkena panas berubah menjadi uap air dan naik ke udara. Peristiwa ini disebut penguapan atau evaporasi. Tumbuhan juga melepaskan uap air melalui daunnya, sehingga uap air di udara semakin banyak.\n\nSemakin tinggi uap air naik, udara di sekitarnya semakin dingin. Udara yang dingin membuat uap air berubah menjadi titik-titik air yang sangat kecil. Peristiwa ini disebut pengembunan atau kondensasi. Kumpulan titik-titik air itulah yang kita lihat sebagai awan.\n\nLama-kelamaan, titik-titik air di dalam awan bergabung menjadi lebih besar dan lebih berat. Ketika awan tidak mampu lagi menahannya, air jatuh ke bumi sebagai hujan. Sebagian air hujan mengalir ke sungai dan laut, sedangkan sebagian lainnya meresap ke dalam tanah menjadi air tanah. Setelah itu, siklus air kembali berulang.\n\nKarena air terus beredar, jumlah air di bumi pada dasarnya tetap. Namun, air bersih yang dapat kita gunakan bisa berkurang jika sungai dan danau tercemar. Oleh karena itu, kita perlu menjaga sumber air agar tetap bersih."
    },
    {
      "id": "pi-kompos",
      "jenis": "Teks Informasi",
      "judul": "Cara Membuat Kompos dari Sampah Dapur",
      "teks": "Setiap hari, dapur menghasilkan sampah seperti sisa sayuran, kulit buah, dan ampas teh. Sampah jenis ini disebut sampah organik karena berasal dari makhluk hidup dan dapat membusuk. Daripada dibuang, sampah organik dapat diolah menjadi kompos, yaitu pupuk alami yang membuat tanah lebih subur. Berikut cara membuatnya di rumah.\n\nPertama, siapkan wadah seperti ember bekas atau keranjang yang diberi beberapa lubang kecil di sisinya. Lubang itu berguna agar udara dapat masuk ke dalam wadah. Kedua, pilih sampah dapur yang akan dijadikan kompos. Jangan memasukkan plastik dan kaca karena tidak dapat membusuk. Hindari juga sisa daging dan minyak goreng karena dapat menimbulkan bau busuk dan mengundang hewan pengganggu.\n\nKetiga, potong sampah menjadi bagian-bagian kecil agar lebih cepat terurai. Keempat, masukkan sampah ke dalam wadah secara berlapis dengan tanah atau daun kering. Lapisan tanah atau daun kering membantu mengurangi bau. Kelima, jaga agar campuran tetap lembap, tetapi tidak terlalu basah. Jika terlihat kering, percikkan sedikit air.\n\nKeenam, aduk campuran seminggu sekali agar udara masuk ke seluruh bagian. Setelah beberapa minggu, kompos siap dipakai. Kompos yang sudah jadi berwarna cokelat kehitaman, teksturnya gembur, dan baunya seperti tanah.\n\nMembuat kompos sendiri memberi dua manfaat sekaligus. Sampah yang dibuang ke tempat pembuangan menjadi lebih sedikit, dan tanaman di rumah mendapat pupuk alami tanpa harus membelinya."
    },
    {
      "id": "pi-mangrove",
      "jenis": "Teks Informasi",
      "judul": "Hutan Mangrove, Benteng Hijau di Tepi Pantai",
      "teks": "Hutan mangrove adalah hutan yang tumbuh di daerah pantai dan muara sungai. Di tempat itu, air laut yang asin bercampur dengan air sungai yang tawar sehingga airnya disebut air payau. Indonesia memiliki hutan mangrove yang sangat luas karena negara kita mempunyai garis pantai yang panjang.\n\nTumbuhan mangrove memiliki bentuk akar yang unik. Sebagian jenis mangrove mempunyai akar yang mencuat ke atas permukaan lumpur, sedangkan jenis lainnya memiliki akar yang bercabang seperti kaki-kaki penyangga. Akar-akar ini mencengkeram lumpur dengan kuat sehingga pohon tetap berdiri walaupun diterjang ombak dan pasang surut air laut.\n\nHutan mangrove memiliki banyak manfaat. Akar mangrove menahan tanah di tepi pantai sehingga pantai tidak mudah terkikis ombak. Pengikisan pantai oleh ombak ini disebut abrasi. Selain itu, di sela-sela akar mangrove, ikan, udang, dan kepiting dapat bertelur dan membesarkan anak-anaknya dengan aman. Hutan mangrove juga menjadi tempat tinggal berbagai jenis burung.\n\nSayangnya, hutan mangrove di beberapa daerah semakin berkurang. Ada pohon mangrove yang ditebang untuk membuka tambak atau permukiman, dan ada pula yang rusak karena tumpukan sampah. Untuk menjaganya, banyak sekolah dan kelompok warga melakukan kegiatan menanam bibit mangrove di pantai yang rusak. Dengan menjaga hutan mangrove, kita ikut melindungi pantai dan makhluk hidup di sekitarnya."
    },
    {
      "id": "pi-pameran",
      "jenis": "Teks Informasi",
      "judul": "Siswa SD Nusa Bakti Pamerkan Karya dari Barang Bekas",
      "teks": "Sebanyak 120 siswa kelas 4 sampai kelas 6 SD Nusa Bakti mengadakan pameran karya dari barang bekas pada Sabtu, 15 Februari. Pameran yang berlangsung di aula sekolah sejak pukul 08.00 sampai 12.00 itu dibuka oleh kepala sekolah, Ibu Ratna Dewi.\n\nDalam pameran tersebut, para siswa menampilkan berbagai karya buatan mereka sendiri. Ada pot bunga dari botol plastik, tas dari bungkus kopi, tempat pensil dari kardus, dan lampu hias dari kaleng bekas. Semua karya itu dibuat selama satu bulan di sela-sela pelajaran Seni Budaya dengan bimbingan para guru.\n\nMenurut Ibu Ratna, pameran ini diadakan untuk menumbuhkan kepedulian siswa terhadap lingkungan. “Barang bekas yang biasanya dibuang ternyata bisa menjadi benda yang berguna dan indah. Kami ingin anak-anak terbiasa berpikir kreatif sebelum membuang sesuatu,” ujarnya.\n\nPengunjung pameran tidak hanya orang tua siswa, tetapi juga warga sekitar sekolah. Beberapa karya bahkan dibeli oleh pengunjung. Uang hasil penjualan akan digunakan untuk membeli tempat sampah terpilah bagi setiap kelas.\n\nSalah satu peserta, Bagas dari kelas 6, mengaku senang bisa ikut pameran. “Awalnya saya kira botol bekas tidak ada gunanya. Setelah dibuat menjadi pot, ternyata bagus juga. Sekarang saya jadi suka mengumpulkan botol bekas di rumah,” katanya sambil tersenyum."
    },
    {
      "id": "pi-berangkat-sekolah",
      "jenis": "Teks Informasi",
      "judul": "Berangkat ke Sekolah dengan Cara Sehat",
      "teks": "# Teks A: Berjalan Kaki ke Sekolah\n\nBerjalan kaki adalah cara paling sederhana untuk berangkat ke sekolah. Cara ini cocok bagi siswa yang rumahnya dekat dengan sekolah. Berjalan kaki tidak memerlukan biaya dan tidak menghasilkan asap kendaraan, sehingga udara tetap bersih. Selain itu, berjalan kaki setiap pagi membuat tubuh lebih bugar.\n\nAgar tetap aman, pejalan kaki sebaiknya berjalan di trotoar. Jika tidak ada trotoar, berjalanlah di tepi jalan sambil tetap waspada. Saat menyeberang, gunakan zebra cross atau jembatan penyeberangan, lalu lihat ke kanan dan ke kiri terlebih dahulu.\n\n# Teks B: Bersepeda ke Sekolah\n\nBersepeda dapat menjadi pilihan bagi siswa yang rumahnya agak jauh dari sekolah. Dengan sepeda, perjalanan menjadi lebih cepat daripada berjalan kaki. Sama seperti berjalan kaki, bersepeda tidak menghasilkan asap dan membuat otot kaki menjadi kuat. Bersepeda pun dapat menjadi olahraga ringan yang menyenangkan setiap hari.\n\nSebelum berangkat, periksa dulu rem dan ban sepeda agar tidak terjadi kecelakaan. Pengendara sepeda juga sebaiknya memakai helm untuk melindungi kepala. Di jalan, bersepedalah di jalur sepeda atau di sisi kiri jalan dan patuhi rambu lalu lintas."
    }
  ],
  "soal": [
    {
      "id": "pi-air-01",
      "bacaan": "pi-siklus-air",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “kondensasi” pada paragraf ketiga berarti …",
      "pilihan": [
        {
          "teks": "Perubahan air menjadi uap karena terkena panas matahari",
          "alasan": "Itu arti **penguapan** atau evaporasi yang dijelaskan di paragraf kedua, bukan kondensasi."
        },
        {
          "teks": "Jatuhnya air dari awan ke bumi",
          "alasan": "Itu adalah hujan, yang dijelaskan di paragraf keempat. Kondensasi terjadi lebih dulu, ketika awan baru terbentuk."
        },
        {
          "teks": "Perubahan uap air menjadi titik-titik air karena udara yang dingin",
          "alasan": "Paragraf ketiga menjelaskan bahwa udara yang dingin membuat uap air berubah menjadi titik-titik air yang sangat kecil. Kalimat berikutnya menyebut peristiwa itu **pengembunan atau kondensasi**."
        },
        {
          "teks": "Meresapnya air hujan ke dalam tanah",
          "alasan": "Peristiwa ini disebut di paragraf keempat dan berbeda dengan kondensasi. Air yang meresap menjadi air tanah, bukan awan."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Udara yang dingin membuat uap air berubah menjadi titik-titik air yang sangat kecil. Peristiwa ini disebut pengembunan atau kondensasi."
      ],
      "langkah": [
        {
          "teks": "Istilah sulit sering langsung dijelaskan di teks. Perhatikan kalimat **\"Peristiwa ini disebut ...\"**. Kata \"ini\" merujuk pada peristiwa yang diceritakan di kalimat sebelumnya."
        }
      ]
    },
    {
      "id": "pi-air-02",
      "bacaan": "pi-siklus-air",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa uap air yang naik ke udara dapat berubah menjadi titik-titik air?",
      "pilihan": [
        {
          "teks": "Karena uap air terkena panas matahari",
          "alasan": "Panas matahari justru mengubah air menjadi uap (penguapan), bukan mengubah uap menjadi titik-titik air."
        },
        {
          "teks": "Karena udara di tempat yang tinggi semakin dingin",
          "alasan": "Paragraf ketiga: semakin tinggi uap air naik, udara di sekitarnya semakin dingin, dan **udara yang dingin** membuat uap air berubah menjadi titik-titik air."
        },
        {
          "teks": "Karena tumbuhan melepaskan uap air melalui daunnya",
          "alasan": "Ini menjelaskan asal sebagian uap air (paragraf kedua), bukan penyebab uap air berubah menjadi titik-titik air."
        },
        {
          "teks": "Karena titik-titik air di awan bergabung menjadi berat",
          "alasan": "Penggabungan titik air terjadi setelah awan terbentuk dan menyebabkan hujan (paragraf keempat). Itu bukan penyebab terbentuknya titik-titik air."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Semakin tinggi uap air naik, udara di sekitarnya semakin dingin.",
        "Udara yang dingin membuat uap air berubah menjadi titik-titik air yang sangat kecil."
      ],
      "langkah": [
        {
          "teks": "Pertanyaan **mengapa** meminta sebab. Bagian teks tentang uap air yang berubah menjadi titik-titik air ada di paragraf ketiga."
        },
        {
          "tanya": {
            "soal": "Menurut paragraf ketiga, bagaimana keadaan udara di tempat yang tinggi?",
            "pilihan": [
              "Semakin panas",
              "Semakin dingin",
              "Tetap sama"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Udara yang **dingin** itulah yang membuat uap air berubah menjadi titik-titik air."
        }
      ]
    },
    {
      "id": "pi-air-03",
      "bacaan": "pi-siklus-air",
      "topik": "informasi-tersurat",
      "tipe": "pg",
      "acakPilihan": false,
      "teks": "Urutan peristiwa dalam siklus air yang sesuai dengan teks adalah …",
      "pilihan": [
        {
          "teks": "Pengembunan → penguapan → hujan",
          "alasan": "Siklus air tidak dimulai dengan pengembunan. Teks menyebut siklus air **dimulai** ketika panas matahari memanaskan air, yaitu penguapan."
        },
        {
          "teks": "Hujan → pengembunan → penguapan",
          "alasan": "Urutan ini terbalik. Hujan terjadi paling akhir, setelah awan terbentuk."
        },
        {
          "teks": "Penguapan → hujan → pengembunan",
          "alasan": "Hujan tidak bisa turun sebelum ada awan. Awan terbentuk melalui pengembunan, jadi pengembunan harus terjadi sebelum hujan."
        },
        {
          "teks": "Penguapan → pengembunan → hujan",
          "alasan": "Sesuai urutan paragraf: air menguap karena panas matahari (paragraf 2), uap air mengembun menjadi awan (paragraf 3), lalu air jatuh sebagai hujan (paragraf 4)."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Siklus air dimulai ketika panas matahari memanaskan air di laut, sungai, dan danau.",
        "Peristiwa ini disebut pengembunan atau kondensasi.",
        "Ketika awan tidak mampu lagi menahannya, air jatuh ke bumi sebagai hujan."
      ],
      "langkah": [
        {
          "teks": "Teks ini menceritakan siklus air **secara berurutan**: setiap paragraf membahas satu tahap. Perhatikan kata **dimulai** di paragraf kedua dan kata **lama-kelamaan** di paragraf keempat."
        },
        {
          "tanya": {
            "soal": "Peristiwa apa yang terjadi paling awal dalam siklus air?",
            "pilihan": [
              "Hujan",
              "Penguapan",
              "Pengembunan"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Siklus air dimulai dengan **penguapan**, jadi pilihan yang diawali peristiwa lain pasti salah."
        }
      ]
    },
    {
      "id": "pi-air-04",
      "bacaan": "pi-siklus-air",
      "topik": "kesesuaian-isi",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan teks.",
      "pernyataan": [
        {
          "teks": "Tumbuhan ikut menambah uap air di udara.",
          "benar": true,
          "alasan": "Paragraf kedua: tumbuhan melepaskan uap air melalui daunnya, **sehingga uap air di udara semakin banyak**."
        },
        {
          "teks": "Awan adalah kumpulan titik-titik air yang sangat kecil.",
          "benar": true,
          "alasan": "Paragraf ketiga: kumpulan titik-titik air itulah yang kita lihat sebagai **awan**."
        },
        {
          "teks": "Semua air hujan mengalir kembali ke laut.",
          "benar": false,
          "alasan": "Teks menyebut hanya **sebagian** air hujan mengalir ke sungai dan laut, sedangkan sebagian lainnya meresap ke dalam tanah."
        },
        {
          "teks": "Air bersih tidak mungkin berkurang karena air di bumi terus beredar.",
          "benar": false,
          "alasan": "Paragraf terakhir justru menjelaskan bahwa air bersih **bisa berkurang** jika sungai dan danau tercemar."
        }
      ],
      "bukti": [
        "Tumbuhan juga melepaskan uap air melalui daunnya, sehingga uap air di udara semakin banyak.",
        "Kumpulan titik-titik air itulah yang kita lihat sebagai awan.",
        "Sebagian air hujan mengalir ke sungai dan laut, sedangkan sebagian lainnya meresap ke dalam tanah menjadi air tanah.",
        "Namun, air bersih yang dapat kita gunakan bisa berkurang jika sungai dan danau tercemar."
      ],
      "langkah": [
        {
          "teks": "Periksa setiap pernyataan satu per satu. Hati-hati dengan kata **semua** dan **tidak mungkin**. Kata seperti itu sering membuat pernyataan menjadi salah jika teks hanya menyebut \"sebagian\" atau \"bisa\"."
        }
      ]
    },
    {
      "id": "pi-air-05",
      "bacaan": "pi-siklus-air",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Menurut teks, ke mana saja air hujan berpindah setelah jatuh ke bumi? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Mengalir ke sungai",
          "benar": true,
          "alasan": "Paragraf keempat: sebagian air hujan mengalir ke **sungai** dan laut."
        },
        {
          "teks": "Mengalir ke laut",
          "benar": true,
          "alasan": "Disebut di kalimat yang sama: air hujan mengalir ke sungai dan **laut**."
        },
        {
          "teks": "Meresap ke dalam tanah menjadi air tanah",
          "benar": true,
          "alasan": "Paragraf keempat: sebagian lainnya **meresap ke dalam tanah** menjadi air tanah."
        },
        {
          "teks": "Langsung naik kembali menjadi awan",
          "benar": false,
          "alasan": "Teks tidak menyebut air hujan langsung menjadi awan. Air harus menguap dulu agar bisa naik ke udara lagi."
        },
        {
          "teks": "Tersimpan di daun tumbuhan selamanya",
          "benar": false,
          "alasan": "Teks hanya menyebut tumbuhan melepaskan uap air melalui daunnya. Tidak disebutkan ada air hujan yang tersimpan selamanya."
        }
      ],
      "bukti": [
        "Sebagian air hujan mengalir ke sungai dan laut, sedangkan sebagian lainnya meresap ke dalam tanah menjadi air tanah."
      ],
      "langkah": [
        {
          "teks": "Cari bagian yang membahas air hujan setelah sampai di bumi, yaitu **paragraf keempat**. Perhatikan kata **sebagian** dan **sebagian lainnya**: keduanya menunjukkan ada lebih dari satu tempat."
        },
        {
          "tanya": {
            "soal": "Air hujan berpindah ke berapa tempat menurut paragraf keempat?",
            "pilihan": [
              "Satu",
              "Dua",
              "Tiga"
            ],
            "jawaban": "C"
          },
          "setelah": "Betul, ada tiga: sungai, laut, dan ke dalam tanah."
        }
      ]
    },
    {
      "id": "pi-air-06",
      "bacaan": "pi-siklus-air",
      "topik": "simpulan",
      "tipe": "pg",
      "teks": "Simpulan yang tepat berdasarkan seluruh isi teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Air di bumi terus beredar melalui penguapan, pengembunan, dan hujan, sehingga sumber air perlu dijaga agar tetap bersih",
          "alasan": "Pilihan ini merangkum seluruh teks: tahap-tahap siklus air (paragraf 2–4) dan pesan menjaga sumber air (paragraf 5)."
        },
        {
          "teks": "Siklus air hanya terjadi di laut yang luas",
          "alasan": "Terlalu sempit dan tidak sesuai teks. Penguapan terjadi di laut, sungai, dan danau, bahkan dari daun tumbuhan."
        },
        {
          "teks": "Hujan turun karena awan terlalu panas",
          "alasan": "Bertentangan dengan teks. Hujan turun karena titik-titik air di awan bergabung menjadi besar dan berat."
        },
        {
          "teks": "Sumber air tidak perlu dijaga karena jumlah air di bumi pada dasarnya tetap",
          "alasan": "Bertentangan dengan paragraf terakhir. Walaupun jumlah air tetap, air bersih bisa berkurang jika tercemar, jadi sumber air tetap perlu dijaga."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Siklus air adalah peredaran air dari bumi ke udara, lalu kembali lagi ke bumi secara terus-menerus.",
        "Oleh karena itu, kita perlu menjaga sumber air agar tetap bersih."
      ],
      "langkah": [
        {
          "teks": "Simpulan harus mencakup isi **seluruh** teks. Ingat lagi: paragraf 2–4 membahas tahap siklus air, dan paragraf terakhir berisi pesan penulis yang diawali **\"Oleh karena itu\"**."
        }
      ]
    },
    {
      "id": "pi-kompos-01",
      "bacaan": "pi-kompos",
      "topik": "informasi-tersurat",
      "tipe": "pg",
      "teks": "Mengapa wadah untuk membuat kompos perlu diberi beberapa lubang kecil?",
      "pilihan": [
        {
          "teks": "Agar air hujan dapat masuk ke dalam wadah",
          "alasan": "Teks tidak menyebut air hujan. Air justru hanya dipercikkan sedikit bila campuran terlihat kering."
        },
        {
          "teks": "Agar sampah dapat dikeluarkan dengan mudah",
          "alasan": "Lubangnya kecil, jadi bukan untuk mengeluarkan sampah. Teks menyebut gunanya untuk udara."
        },
        {
          "teks": "Agar lalat dapat keluar dari wadah",
          "alasan": "Teks tidak membahas lalat keluar-masuk wadah. Teks justru menyarankan menghindari bahan yang mengundang hewan pengganggu."
        },
        {
          "teks": "Agar udara dapat masuk ke dalam wadah",
          "alasan": "Paragraf kedua: lubang itu berguna **agar udara dapat masuk** ke dalam wadah."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Lubang itu berguna agar udara dapat masuk ke dalam wadah."
      ],
      "langkah": [
        {
          "teks": "Cari kata kunci **lubang** di teks. Kalimat sesudahnya menjelaskan gunanya. Kata **agar** menunjukkan tujuan."
        }
      ]
    },
    {
      "id": "pi-kompos-02",
      "bacaan": "pi-kompos",
      "topik": "informasi-tersurat",
      "tipe": "pg",
      "teks": "Menurut teks, langkah yang dilakukan setelah memotong sampah menjadi bagian-bagian kecil adalah …",
      "pilihan": [
        {
          "teks": "Menyiapkan wadah yang diberi lubang kecil",
          "alasan": "Ini langkah **pertama**, jadi dilakukan sebelum memotong sampah."
        },
        {
          "teks": "Memilih sampah dapur yang akan dijadikan kompos",
          "alasan": "Ini langkah **kedua**, juga dilakukan sebelum memotong sampah."
        },
        {
          "teks": "Memasukkan sampah ke wadah secara berlapis dengan tanah atau daun kering",
          "alasan": "Memotong sampah adalah langkah **ketiga**, dan langkah sesudahnya (**keempat**) adalah memasukkan sampah secara berlapis dengan tanah atau daun kering."
        },
        {
          "teks": "Mengaduk campuran seminggu sekali",
          "alasan": "Mengaduk adalah langkah **keenam**, bukan langkah tepat setelah memotong sampah."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Ketiga, potong sampah menjadi bagian-bagian kecil agar lebih cepat terurai.",
        "Keempat, masukkan sampah ke dalam wadah secara berlapis dengan tanah atau daun kering."
      ],
      "langkah": [
        {
          "teks": "Teks prosedur memakai kata urutan **Pertama, Kedua, Ketiga**, dan seterusnya. Cari dulu langkah memotong sampah, lalu lihat langkah bernomor sesudahnya."
        },
        {
          "tanya": {
            "soal": "Memotong sampah adalah langkah ke berapa?",
            "pilihan": [
              "Kedua",
              "Ketiga",
              "Keempat"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul, langkah **ketiga**. Jadi, yang ditanyakan adalah langkah **keempat**."
        }
      ]
    },
    {
      "id": "pi-kompos-03",
      "bacaan": "pi-kompos",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Bahan apa saja yang sebaiknya TIDAK dimasukkan ke dalam wadah kompos menurut teks? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Plastik",
          "benar": true,
          "alasan": "Paragraf kedua: jangan memasukkan plastik karena **tidak dapat membusuk**."
        },
        {
          "teks": "Kulit buah",
          "benar": false,
          "alasan": "Kulit buah termasuk sampah organik yang disebut di paragraf pertama sebagai bahan kompos."
        },
        {
          "teks": "Sisa daging",
          "benar": true,
          "alasan": "Paragraf kedua: hindari sisa daging karena dapat menimbulkan bau busuk dan mengundang hewan pengganggu."
        },
        {
          "teks": "Ampas teh",
          "benar": false,
          "alasan": "Ampas teh disebut di paragraf pertama sebagai contoh sampah dapur organik yang bisa dijadikan kompos."
        },
        {
          "teks": "Minyak goreng",
          "benar": true,
          "alasan": "Paragraf kedua menyebut minyak goreng juga harus dihindari, sama seperti sisa daging."
        }
      ],
      "bukti": [
        "Jangan memasukkan plastik dan kaca karena tidak dapat membusuk.",
        "Hindari juga sisa daging dan minyak goreng karena dapat menimbulkan bau busuk dan mengundang hewan pengganggu.",
        "Setiap hari, dapur menghasilkan sampah seperti sisa sayuran, kulit buah, dan ampas teh."
      ],
      "langkah": [
        {
          "teks": "Perhatikan kata **TIDAK** di soal: kamu harus memilih bahan yang dilarang. Bahan yang dilarang disebut di paragraf kedua setelah kata **Jangan** dan **Hindari**."
        }
      ]
    },
    {
      "id": "pi-kompos-04",
      "bacaan": "pi-kompos",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Apa yang dapat terjadi jika sisa daging dimasukkan ke dalam wadah kompos?",
      "pilihan": [
        {
          "teks": "Kompos menjadi lebih cepat matang",
          "alasan": "Teks tidak menyebut daging mempercepat kompos. Yang membuat sampah cepat terurai adalah memotongnya menjadi bagian kecil."
        },
        {
          "teks": "Timbul bau busuk dan datang hewan pengganggu",
          "alasan": "Paragraf kedua: sisa daging dan minyak goreng **dapat menimbulkan bau busuk dan mengundang hewan pengganggu**."
        },
        {
          "teks": "Campuran kompos menjadi terlalu kering",
          "alasan": "Teks tidak menghubungkan sisa daging dengan campuran yang kering."
        },
        {
          "teks": "Udara tidak dapat masuk ke dalam wadah",
          "alasan": "Masuknya udara diatur oleh lubang wadah dan pengadukan, bukan oleh sisa daging."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Hindari juga sisa daging dan minyak goreng karena dapat menimbulkan bau busuk dan mengundang hewan pengganggu."
      ],
      "langkah": [
        {
          "teks": "Cari kalimat yang menyebut **sisa daging**. Kata **karena** di kalimat itu menjelaskan alasan larangannya, yaitu akibat yang terjadi jika daging dimasukkan."
        },
        {
          "tanya": {
            "soal": "Kalimat tentang sisa daging diawali kata …",
            "pilihan": [
              "Hindari",
              "Siapkan",
              "Aduk"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Kata **hindari** berarti sebaiknya tidak dilakukan, dan alasannya ada setelah kata \"karena\"."
        }
      ]
    },
    {
      "id": "pi-kompos-05",
      "bacaan": "pi-kompos",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “gembur” pada paragraf keempat paling dekat maknanya dengan …",
      "pilihan": [
        {
          "teks": "Lunak dan mudah dihancurkan",
          "alasan": "Kompos yang sudah jadi digambarkan bertekstur gembur dan berbau seperti tanah, sama seperti tanah subur yang tidak keras dan mudah diremas atau dihancurkan."
        },
        {
          "teks": "Keras dan padat",
          "alasan": "Kebalikan dari gembur. Sampah yang sudah terurai menjadi remah, bukan keras dan padat."
        },
        {
          "teks": "Basah dan lengket",
          "alasan": "Paragraf ketiga justru meminta campuran **tidak terlalu basah**, jadi kompos yang baik tidak lengket."
        },
        {
          "teks": "Kering dan berdebu",
          "alasan": "Paragraf ketiga meminta campuran dijaga tetap **lembap**, jadi kompos yang baik tidak kering berdebu."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Kompos yang sudah jadi berwarna cokelat kehitaman, teksturnya gembur, dan baunya seperti tanah."
      ],
      "langkah": [
        {
          "teks": "Kata **gembur** menjelaskan **tekstur** (rasa saat diraba) kompos yang sudah jadi. Bayangkan tanah kebun yang subur dan mudah dicangkul, lalu coba ganti kata gembur dengan setiap pilihan."
        },
        {
          "tanya": {
            "soal": "Menurut paragraf ketiga, campuran kompos sebaiknya …",
            "pilihan": [
              "Lembap, tetapi tidak terlalu basah",
              "Sangat basah",
              "Kering sekali"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Karena itu, kompos yang baik tidak basah lengket dan tidak kering berdebu. Yang tersisa adalah **lunak dan mudah dihancurkan**."
        }
      ]
    },
    {
      "id": "pi-kompos-06",
      "bacaan": "pi-kompos",
      "topik": "sikap-refleksi",
      "tipe": "pg",
      "teks": "Setelah membaca teks tersebut, Rina ingin mengurangi sampah di rumahnya. Tindakan yang paling sesuai dengan isi teks adalah …",
      "pilihan": [
        {
          "teks": "Membakar sisa sayuran di halaman rumah",
          "alasan": "Teks tidak menyarankan membakar sampah. Sisa sayuran seharusnya diolah menjadi kompos."
        },
        {
          "teks": "Memasukkan semua sampah, termasuk plastik, ke wadah kompos",
          "alasan": "Bertentangan dengan teks yang melarang memasukkan plastik karena tidak dapat membusuk."
        },
        {
          "teks": "Memisahkan sisa sayuran dan kulit buah untuk diolah menjadi kompos",
          "alasan": "Sejalan dengan teks: sampah organik dapat diolah menjadi kompos sehingga sampah yang dibuang menjadi lebih sedikit."
        },
        {
          "teks": "Membuang sampah dapur ke selokan agar cepat hilang",
          "alasan": "Teks tidak menyarankan hal ini. Sampah di selokan justru mencemari lingkungan dan tidak mengurangi sampah."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Daripada dibuang, sampah organik dapat diolah menjadi kompos, yaitu pupuk alami yang membuat tanah lebih subur.",
        "Sampah yang dibuang ke tempat pembuangan menjadi lebih sedikit"
      ],
      "langkah": [
        {
          "teks": "Tindakan yang tepat harus **sejalan dengan saran** di teks. Ingat: teks menyarankan mengolah sampah organik menjadi kompos dan melarang memasukkan plastik."
        }
      ]
    },
    {
      "id": "pi-mangrove-01",
      "bacaan": "pi-mangrove",
      "topik": "gagasan-pokok",
      "tipe": "pg",
      "teks": "Gagasan pokok paragraf ketiga teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Ikan, udang, dan kepiting bertelur di sela-sela akar mangrove",
          "alasan": "Ini hanya salah satu **rincian** manfaat mangrove. Gagasan pokok harus mencakup isi seluruh paragraf."
        },
        {
          "teks": "Hutan mangrove memiliki banyak manfaat",
          "alasan": "Kalimat pertama paragraf ketiga (kalimat utama) berbunyi \"Hutan mangrove memiliki banyak manfaat\". Kalimat-kalimat berikutnya menjelaskan manfaat itu satu per satu."
        },
        {
          "teks": "Abrasi adalah pengikisan pantai oleh ombak",
          "alasan": "Ini hanya penjelasan istilah di dalam paragraf, bukan ide utama paragraf."
        },
        {
          "teks": "Hutan mangrove semakin berkurang karena ditebang",
          "alasan": "Berkurangnya hutan mangrove dibahas di paragraf **keempat**, bukan ketiga."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Hutan mangrove memiliki banyak manfaat."
      ],
      "langkah": [
        {
          "teks": "Gagasan pokok biasanya ada di **kalimat utama**. Baca kalimat pertama paragraf ketiga, lalu periksa apakah kalimat lain menjelaskan kalimat itu."
        },
        {
          "tanya": {
            "soal": "Kalimat-kalimat setelah kalimat pertama paragraf ketiga menjelaskan tentang …",
            "pilihan": [
              "Manfaat-manfaat mangrove",
              "Cara menebang mangrove",
              "Bentuk daun mangrove"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Karena semua kalimat menjelaskan manfaat, gagasan pokoknya adalah **hutan mangrove memiliki banyak manfaat**."
        }
      ]
    },
    {
      "id": "pi-mangrove-02",
      "bacaan": "pi-mangrove",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Berdasarkan teks, yang dimaksud dengan abrasi adalah …",
      "pilihan": [
        {
          "teks": "Campuran air laut dan air sungai",
          "alasan": "Itu adalah pengertian **air payau** di paragraf pertama, bukan abrasi."
        },
        {
          "teks": "Penebangan pohon mangrove untuk membuat tambak",
          "alasan": "Penebangan dibahas di paragraf keempat dan bukan arti kata abrasi."
        },
        {
          "teks": "Naik dan turunnya permukaan air laut",
          "alasan": "Itu adalah pasang surut, yang disebut di paragraf kedua. Abrasi berbeda."
        },
        {
          "teks": "Pengikisan pantai oleh ombak",
          "alasan": "Paragraf ketiga menjelaskan langsung: **pengikisan pantai oleh ombak ini disebut abrasi**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Pengikisan pantai oleh ombak ini disebut abrasi."
      ],
      "langkah": [
        {
          "teks": "Cari kata **abrasi** di teks. Kalimat yang memakai pola \"... disebut abrasi\" berisi artinya."
        }
      ]
    },
    {
      "id": "pi-mangrove-03",
      "bacaan": "pi-mangrove",
      "topik": "kesesuaian-isi",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan teks.",
      "pernyataan": [
        {
          "teks": "Air di daerah hutan mangrove disebut air payau karena merupakan campuran air asin dan air tawar.",
          "benar": true,
          "alasan": "Paragraf pertama: air laut yang asin bercampur dengan air sungai yang tawar **sehingga airnya disebut air payau**."
        },
        {
          "teks": "Semua jenis mangrove memiliki akar yang bercabang seperti kaki-kaki penyangga.",
          "benar": false,
          "alasan": "Paragraf kedua menjelaskan ada dua bentuk akar. Akar bercabang seperti kaki penyangga hanya dimiliki **sebagian** jenis; jenis lain memiliki akar yang mencuat ke atas permukaan lumpur."
        },
        {
          "teks": "Akar mangrove membuat pohon tetap berdiri walaupun diterjang ombak.",
          "benar": true,
          "alasan": "Paragraf kedua: akar-akar mangrove mencengkeram lumpur dengan kuat **sehingga pohon tetap berdiri walaupun diterjang ombak**."
        },
        {
          "teks": "Hutan mangrove di Indonesia tidak pernah mengalami kerusakan.",
          "benar": false,
          "alasan": "Paragraf keempat menyebut hutan mangrove di beberapa daerah **semakin berkurang** karena ditebang dan rusak oleh tumpukan sampah."
        }
      ],
      "bukti": [
        "air laut yang asin bercampur dengan air sungai yang tawar sehingga airnya disebut air payau",
        "Sebagian jenis mangrove mempunyai akar yang mencuat ke atas permukaan lumpur, sedangkan jenis lainnya memiliki akar yang bercabang seperti kaki-kaki penyangga.",
        "Akar-akar ini mencengkeram lumpur dengan kuat sehingga pohon tetap berdiri walaupun diterjang ombak dan pasang surut air laut.",
        "Sayangnya, hutan mangrove di beberapa daerah semakin berkurang."
      ],
      "langkah": [
        {
          "teks": "Cocokkan setiap pernyataan dengan paragrafnya: air payau (paragraf 1), bentuk akar (paragraf 2), dan kerusakan mangrove (paragraf 4). Waspadai kata **semua** dan **tidak pernah**."
        }
      ]
    },
    {
      "id": "pi-mangrove-04",
      "bacaan": "pi-mangrove",
      "topik": "sebab-akibat",
      "tipe": "mcma",
      "teks": "Menurut teks, apa saja penyebab hutan mangrove di beberapa daerah semakin berkurang? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Pohon mangrove ditebang untuk membuka tambak",
          "benar": true,
          "alasan": "Paragraf keempat: ada pohon mangrove yang **ditebang untuk membuka tambak**."
        },
        {
          "teks": "Pohon mangrove ditebang untuk permukiman",
          "benar": true,
          "alasan": "Disebut di kalimat yang sama: mangrove ditebang untuk membuka tambak **atau permukiman**."
        },
        {
          "teks": "Tumpukan sampah merusak mangrove",
          "benar": true,
          "alasan": "Paragraf keempat: ada pula mangrove yang **rusak karena tumpukan sampah**."
        },
        {
          "teks": "Terlalu banyak bibit mangrove ditanam",
          "benar": false,
          "alasan": "Menanam bibit justru cara **menjaga** hutan mangrove, bukan penyebab berkurangnya."
        },
        {
          "teks": "Kepiting memakan akar mangrove",
          "benar": false,
          "alasan": "Teks menyebut kepiting bertelur dan membesarkan anak di sela akar mangrove, bukan merusaknya."
        }
      ],
      "bukti": [
        "Ada pohon mangrove yang ditebang untuk membuka tambak atau permukiman, dan ada pula yang rusak karena tumpukan sampah."
      ],
      "langkah": [
        {
          "teks": "Penyebab kerusakan dibahas di **paragraf keempat**, setelah kata **Sayangnya**. Kata itu menandai bagian yang berisi masalah."
        }
      ]
    },
    {
      "id": "pi-mangrove-05",
      "bacaan": "pi-mangrove",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa ikan, udang, dan kepiting dapat bertelur di hutan mangrove?",
      "pilihan": [
        {
          "teks": "Karena air di hutan mangrove sepenuhnya tawar",
          "alasan": "Bertentangan dengan paragraf pertama. Air di hutan mangrove adalah air payau, campuran air asin dan air tawar."
        },
        {
          "teks": "Karena burung-burung menjaga telur mereka",
          "alasan": "Teks hanya menyebut burung tinggal di hutan mangrove, bukan menjaga telur ikan atau kepiting."
        },
        {
          "teks": "Karena sela-sela akar mangrove menjadi tempat yang aman untuk bertelur dan membesarkan anak",
          "alasan": "Paragraf ketiga: di sela-sela akar mangrove, ikan, udang, dan kepiting dapat bertelur dan membesarkan anak-anaknya **dengan aman**."
        },
        {
          "teks": "Karena di hutan mangrove tidak pernah ada ombak",
          "alasan": "Paragraf kedua menyebut pohon mangrove diterjang ombak, jadi ombak tetap ada di sana."
        }
      ],
      "kunci": "C",
      "bukti": [
        "di sela-sela akar mangrove, ikan, udang, dan kepiting dapat bertelur dan membesarkan anak-anaknya dengan aman"
      ],
      "langkah": [
        {
          "teks": "Cari kata **bertelur** di teks, lalu baca kalimatnya sampai akhir."
        },
        {
          "tanya": {
            "soal": "Kata di akhir kalimat itu yang menjelaskan keadaan di sela-sela akar mangrove adalah …",
            "pilihan": [
              "Dengan aman",
              "Di tepi pantai",
              "Berbagai jenis"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Sela-sela akar mangrove adalah tempat yang **aman** bagi hewan-hewan itu."
        }
      ]
    },
    {
      "id": "pi-mangrove-06",
      "bacaan": "pi-mangrove",
      "topik": "sikap-refleksi",
      "tipe": "pg",
      "teks": "Kegiatan yang paling tepat dilakukan siswa untuk ikut menjaga hutan mangrove berdasarkan teks adalah …",
      "pilihan": [
        {
          "teks": "Mengambil kayu mangrove untuk kayu bakar",
          "alasan": "Menebang atau mengambil kayu mangrove justru membuat hutan mangrove berkurang."
        },
        {
          "teks": "Ikut menanam bibit mangrove dan tidak membuang sampah di pantai",
          "alasan": "Sejalan dengan paragraf keempat: penebangan dan sampah merusak mangrove, sedangkan menanam bibit adalah cara menjaganya."
        },
        {
          "teks": "Membuat tambak baru di tepi pantai",
          "alasan": "Membuka tambak disebut sebagai salah satu alasan pohon mangrove ditebang."
        },
        {
          "teks": "Memindahkan kepiting dari hutan mangrove ke kolam rumah",
          "alasan": "Teks tidak menyarankan hal ini. Kepiting justru aman berkembang biak di hutan mangrove."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Untuk menjaganya, banyak sekolah dan kelompok warga melakukan kegiatan menanam bibit mangrove di pantai yang rusak."
      ],
      "langkah": [
        {
          "teks": "Cari kalimat yang diawali **Untuk menjaganya** di paragraf terakhir. Pilih tindakan yang sejalan dengan kalimat itu dan tidak termasuk penyebab kerusakan."
        }
      ]
    },
    {
      "id": "pi-pameran-01",
      "bacaan": "pi-pameran",
      "topik": "informasi-tersurat",
      "tipe": "pg",
      "acakPilihan": false,
      "teks": "Paragraf pertama berita tersebut menjawab beberapa pertanyaan 5W+1H. Pertanyaan yang TIDAK dijawab di paragraf pertama adalah …",
      "pilihan": [
        {
          "teks": "Apa kegiatan yang diadakan?",
          "alasan": "Dijawab di paragraf pertama: kegiatannya adalah **pameran karya dari barang bekas**."
        },
        {
          "teks": "Siapa yang mengadakan kegiatan?",
          "alasan": "Dijawab di paragraf pertama: **120 siswa kelas 4 sampai kelas 6 SD Nusa Bakti**."
        },
        {
          "teks": "Kapan kegiatan diadakan?",
          "alasan": "Dijawab di paragraf pertama: **Sabtu, 15 Februari**, pukul 08.00 sampai 12.00."
        },
        {
          "teks": "Mengapa kegiatan itu diadakan?",
          "alasan": "Alasan diadakannya pameran baru dijelaskan di **paragraf ketiga** oleh Ibu Ratna, yaitu untuk menumbuhkan kepedulian siswa terhadap lingkungan."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Sebanyak 120 siswa kelas 4 sampai kelas 6 SD Nusa Bakti mengadakan pameran karya dari barang bekas pada Sabtu, 15 Februari.",
        "Menurut Ibu Ratna, pameran ini diadakan untuk menumbuhkan kepedulian siswa terhadap lingkungan."
      ],
      "langkah": [
        {
          "teks": "Paragraf pertama berita biasanya berisi informasi terpenting: **apa, siapa, kapan, dan di mana**. Periksa setiap pertanyaan: apakah jawabannya ada di paragraf pertama?"
        },
        {
          "tanya": {
            "soal": "Di paragraf berapa alasan diadakannya pameran dijelaskan?",
            "pilihan": [
              "Paragraf pertama",
              "Paragraf ketiga",
              "Paragraf kelima"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Karena alasannya baru ada di paragraf ketiga, pertanyaan **mengapa** tidak dijawab di paragraf pertama."
        }
      ]
    },
    {
      "id": "pi-pameran-02",
      "bacaan": "pi-pameran",
      "topik": "topik-judul",
      "tipe": "pg",
      "teks": "Judul lain yang paling tepat untuk berita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Bagas Senang Mengumpulkan Botol Bekas",
          "alasan": "Terlalu sempit. Cerita Bagas hanya dibahas di paragraf terakhir."
        },
        {
          "teks": "Pameran Barang Bekas Tumbuhkan Kepedulian Lingkungan Siswa",
          "alasan": "Judul ini mencakup isi utama berita: pameran karya dari barang bekas (paragraf 1, 2, dan 4) dan tujuannya menumbuhkan kepedulian lingkungan (paragraf 3)."
        },
        {
          "teks": "Cara Membuat Lampu Hias dari Kaleng Bekas",
          "alasan": "Berita hanya menyebut lampu hias sebagai salah satu karya, tidak menjelaskan cara membuatnya."
        },
        {
          "teks": "Warga Sumbangkan Tempat Sampah untuk Sekolah",
          "alasan": "Tidak sesuai berita. Tempat sampah terpilah akan **dibeli** dengan uang hasil penjualan karya, bukan disumbangkan warga."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Sebanyak 120 siswa kelas 4 sampai kelas 6 SD Nusa Bakti mengadakan pameran karya dari barang bekas pada Sabtu, 15 Februari.",
        "Menurut Ibu Ratna, pameran ini diadakan untuk menumbuhkan kepedulian siswa terhadap lingkungan."
      ],
      "langkah": [
        {
          "teks": "Judul yang tepat harus mencakup isi **seluruh** berita, bukan satu paragraf saja. Ingat lagi: berita ini tentang kegiatan apa, dan untuk apa kegiatan itu diadakan?"
        }
      ]
    },
    {
      "id": "pi-pameran-03",
      "bacaan": "pi-pameran",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa pameran tersebut diadakan menurut Ibu Ratna?",
      "pilihan": [
        {
          "teks": "Untuk mengumpulkan dana pembangunan aula sekolah",
          "alasan": "Aula hanya disebut sebagai tempat pameran. Uang hasil penjualan pun dipakai untuk membeli tempat sampah terpilah, bukan membangun aula."
        },
        {
          "teks": "Agar siswa dapat menjual karya ke luar kota",
          "alasan": "Berita tidak menyebut penjualan ke luar kota. Karya dibeli oleh pengunjung pameran."
        },
        {
          "teks": "Untuk menggantikan pelajaran Seni Budaya",
          "alasan": "Pelajaran Seni Budaya tidak digantikan. Karya justru dibuat di sela-sela pelajaran Seni Budaya."
        },
        {
          "teks": "Untuk menumbuhkan kepedulian siswa terhadap lingkungan",
          "alasan": "Paragraf ketiga: menurut Ibu Ratna, pameran ini diadakan **untuk menumbuhkan kepedulian siswa terhadap lingkungan**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Menurut Ibu Ratna, pameran ini diadakan untuk menumbuhkan kepedulian siswa terhadap lingkungan."
      ],
      "langkah": [
        {
          "teks": "Soal menanyakan alasan **menurut Ibu Ratna**. Cari nama Ibu Ratna di paragraf ketiga."
        },
        {
          "tanya": {
            "soal": "Kata yang menunjukkan tujuan dalam kalimat tentang Ibu Ratna adalah …",
            "pilihan": [
              "Untuk",
              "Menurut",
              "Ini"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Setelah kata **untuk** disebutkan tujuannya: menumbuhkan kepedulian siswa terhadap lingkungan."
        }
      ]
    },
    {
      "id": "pi-pameran-04",
      "bacaan": "pi-pameran",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Karya apa saja yang ditampilkan dalam pameran menurut berita tersebut? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Pot bunga dari botol plastik",
          "benar": true,
          "alasan": "Disebut di paragraf kedua: ada **pot bunga dari botol plastik**."
        },
        {
          "teks": "Tas dari bungkus kopi",
          "benar": true,
          "alasan": "Disebut di paragraf kedua: ada **tas dari bungkus kopi**."
        },
        {
          "teks": "Mainan mobil dari kardus",
          "benar": false,
          "alasan": "Kardus dibuat menjadi **tempat pensil**, bukan mainan mobil."
        },
        {
          "teks": "Lampu hias dari kaleng bekas",
          "benar": true,
          "alasan": "Disebut di paragraf kedua: ada **lampu hias dari kaleng bekas**."
        },
        {
          "teks": "Tempat sampah terpilah",
          "benar": false,
          "alasan": "Tempat sampah terpilah bukan karya siswa. Benda itu **akan dibeli** dengan uang hasil penjualan karya."
        }
      ],
      "bukti": [
        "Ada pot bunga dari botol plastik, tas dari bungkus kopi, tempat pensil dari kardus, dan lampu hias dari kaleng bekas."
      ],
      "langkah": [
        {
          "teks": "Daftar karya ada di **paragraf kedua**. Cocokkan setiap pilihan dengan daftar itu dengan teliti, termasuk **bahan** pembuatnya."
        },
        {
          "tanya": {
            "soal": "Menurut paragraf kedua, kardus dibuat menjadi …",
            "pilihan": [
              "Mainan mobil",
              "Tempat pensil",
              "Tas"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Jadi pilihan \"mainan mobil dari kardus\" tidak sesuai dengan berita."
        }
      ]
    },
    {
      "id": "pi-pameran-05",
      "bacaan": "pi-pameran",
      "topik": "kesesuaian-isi",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan berita.",
      "pernyataan": [
        {
          "teks": "Pameran hanya dikunjungi oleh orang tua siswa.",
          "benar": false,
          "alasan": "Paragraf keempat: pengunjung pameran **tidak hanya** orang tua siswa, tetapi juga warga sekitar sekolah."
        },
        {
          "teks": "Karya siswa dibuat selama satu bulan dengan bimbingan guru.",
          "benar": true,
          "alasan": "Paragraf kedua: semua karya dibuat **selama satu bulan** di sela-sela pelajaran Seni Budaya **dengan bimbingan para guru**."
        },
        {
          "teks": "Uang hasil penjualan karya akan dipakai untuk membeli tempat sampah terpilah.",
          "benar": true,
          "alasan": "Paragraf keempat: uang hasil penjualan akan digunakan untuk membeli **tempat sampah terpilah** bagi setiap kelas."
        },
        {
          "teks": "Sejak awal Bagas yakin botol bekas sangat berguna.",
          "benar": false,
          "alasan": "Bagas berkata, \"Awalnya saya kira botol bekas tidak ada gunanya.\" Ia baru berubah pikiran setelah membuat pot."
        }
      ],
      "bukti": [
        "Pengunjung pameran tidak hanya orang tua siswa, tetapi juga warga sekitar sekolah.",
        "Semua karya itu dibuat selama satu bulan di sela-sela pelajaran Seni Budaya dengan bimbingan para guru.",
        "Uang hasil penjualan akan digunakan untuk membeli tempat sampah terpilah bagi setiap kelas.",
        "Awalnya saya kira botol bekas tidak ada gunanya."
      ],
      "langkah": [
        {
          "teks": "Periksa setiap pernyataan dengan paragraf yang membahasnya. Hati-hati dengan kata **hanya** dan **sejak awal**; bandingkan dengan kata \"tidak hanya\" dan \"awalnya\" di teks."
        }
      ]
    },
    {
      "id": "pi-pameran-06",
      "bacaan": "pi-pameran",
      "topik": "simpulan",
      "tipe": "pg",
      "teks": "Simpulan yang tepat berdasarkan berita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Pameran karya dari barang bekas membuat siswa lebih kreatif dan peduli lingkungan",
          "alasan": "Sesuai dengan tujuan pameran menurut Ibu Ratna (paragraf 3) dan dibuktikan oleh perubahan sikap Bagas yang kini suka mengumpulkan botol bekas (paragraf 5)."
        },
        {
          "teks": "Barang bekas sebaiknya langsung dibuang karena tidak berguna",
          "alasan": "Bertentangan dengan berita. Barang bekas ternyata bisa menjadi benda yang berguna dan indah."
        },
        {
          "teks": "Pameran hanya bermanfaat bagi pengunjung yang membeli karya",
          "alasan": "Terlalu sempit dan tidak sesuai berita. Pameran juga bermanfaat bagi siswa dan sekolah, misalnya untuk membeli tempat sampah terpilah."
        },
        {
          "teks": "Siswa SD Nusa Bakti tidak suka pelajaran Seni Budaya",
          "alasan": "Tidak ada informasi itu di berita. Siswa justru membuat karya di pelajaran Seni Budaya."
        }
      ],
      "kunci": "A",
      "bukti": [
        "“Barang bekas yang biasanya dibuang ternyata bisa menjadi benda yang berguna dan indah.",
        "Sekarang saya jadi suka mengumpulkan botol bekas di rumah,”"
      ],
      "langkah": [
        {
          "teks": "Simpulan menggabungkan isi penting berita: **tujuan** pameran (paragraf 3) dan **hasilnya** bagi siswa, misalnya Bagas (paragraf 5)."
        }
      ]
    },
    {
      "id": "pi-berangkat-01",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "membandingkan-teks",
      "tipe": "pg",
      "teks": "Persamaan isi Teks A dan Teks B adalah keduanya menjelaskan bahwa cara berangkat ke sekolah itu …",
      "pilihan": [
        {
          "teks": "Cocok untuk siswa yang rumahnya agak jauh",
          "alasan": "Hanya Teks B yang menyebut rumah agak jauh. Teks A justru menyebut berjalan kaki cocok untuk rumah yang **dekat**."
        },
        {
          "teks": "Mengharuskan pemakaian helm",
          "alasan": "Helm hanya disebut di Teks B untuk pengendara sepeda."
        },
        {
          "teks": "Tidak menghasilkan asap kendaraan",
          "alasan": "Teks A: berjalan kaki tidak menghasilkan asap kendaraan. Teks B: **sama seperti berjalan kaki**, bersepeda tidak menghasilkan asap. Keduanya menyebut hal ini."
        },
        {
          "teks": "Tidak memerlukan biaya sama sekali",
          "alasan": "Hanya Teks A yang menyebut tidak memerlukan biaya. Teks B tidak membahas biaya."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Berjalan kaki tidak memerlukan biaya dan tidak menghasilkan asap kendaraan, sehingga udara tetap bersih.",
        "Sama seperti berjalan kaki, bersepeda tidak menghasilkan asap dan membuat otot kaki menjadi kuat."
      ],
      "langkah": [
        {
          "teks": "**Persamaan** berarti hal yang disebut di **kedua** teks. Untuk setiap pilihan, cek: apakah ada di Teks A? Apakah ada juga di Teks B? Hanya pilihan yang ada di keduanya yang benar."
        },
        {
          "tanya": {
            "soal": "Frasa di Teks B yang menunjukkan persamaan dengan Teks A adalah …",
            "pilihan": [
              "Sama seperti berjalan kaki",
              "Sebelum berangkat",
              "Di jalan"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Frasa **sama seperti** menandai persamaan, dan setelahnya disebut bahwa bersepeda tidak menghasilkan asap."
        }
      ]
    },
    {
      "id": "pi-berangkat-02",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "membandingkan-teks",
      "tipe": "pg",
      "teks": "Perbedaan isi Teks A dan Teks B yang paling tepat adalah …",
      "pilihan": [
        {
          "teks": "Teks A menyebut cara yang cocok untuk rumah yang dekat, sedangkan Teks B untuk rumah yang agak jauh",
          "alasan": "Teks A: berjalan kaki cocok bagi siswa yang rumahnya **dekat**. Teks B: bersepeda menjadi pilihan bagi siswa yang rumahnya **agak jauh**."
        },
        {
          "teks": "Teks A membahas cara agar tetap aman, sedangkan Teks B tidak",
          "alasan": "Keduanya membahas keamanan. Teks A membahas trotoar dan cara menyeberang, Teks B membahas rem, helm, dan jalur sepeda."
        },
        {
          "teks": "Teks A menyebut manfaat bagi tubuh, sedangkan Teks B tidak",
          "alasan": "Teks B juga menyebut manfaat bagi tubuh, yaitu membuat **otot kaki menjadi kuat**."
        },
        {
          "teks": "Teks A membahas sepeda motor, sedangkan Teks B membahas sepeda",
          "alasan": "Teks A membahas berjalan kaki, bukan sepeda motor."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Cara ini cocok bagi siswa yang rumahnya dekat dengan sekolah.",
        "Bersepeda dapat menjadi pilihan bagi siswa yang rumahnya agak jauh dari sekolah."
      ],
      "langkah": [
        {
          "teks": "**Perbedaan** berarti hal yang dijelaskan berbeda di kedua teks. Hati-hati: pilihan yang menyebut \"Teks B tidak\" harus benar-benar tidak ada di Teks B."
        }
      ]
    },
    {
      "id": "pi-berangkat-03",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Menurut Teks B, apa saja yang perlu dilakukan pengendara sepeda agar tetap aman? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Memeriksa rem dan ban sebelum berangkat",
          "benar": true,
          "alasan": "Teks B: sebelum berangkat, **periksa dulu rem dan ban sepeda** agar tidak terjadi kecelakaan."
        },
        {
          "teks": "Memakai helm",
          "benar": true,
          "alasan": "Teks B: pengendara sepeda sebaiknya **memakai helm** untuk melindungi kepala."
        },
        {
          "teks": "Bersepeda di jalur sepeda atau di sisi kiri jalan",
          "benar": true,
          "alasan": "Teks B: bersepedalah **di jalur sepeda atau di sisi kiri jalan** dan patuhi rambu lalu lintas."
        },
        {
          "teks": "Berjalan di trotoar",
          "benar": false,
          "alasan": "Ini saran untuk **pejalan kaki** di Teks A, bukan untuk pengendara sepeda di Teks B."
        },
        {
          "teks": "Bersepeda secepat mungkin agar tidak terlambat",
          "benar": false,
          "alasan": "Teks B tidak menyarankan bersepeda secepat mungkin. Teks B justru meminta pengendara mematuhi rambu lalu lintas."
        }
      ],
      "bukti": [
        "Sebelum berangkat, periksa dulu rem dan ban sepeda agar tidak terjadi kecelakaan.",
        "Pengendara sepeda juga sebaiknya memakai helm untuk melindungi kepala.",
        "Di jalan, bersepedalah di jalur sepeda atau di sisi kiri jalan dan patuhi rambu lalu lintas."
      ],
      "langkah": [
        {
          "teks": "Soal hanya menanyakan **Teks B**. Jangan tertukar dengan saran untuk pejalan kaki di Teks A. Saran keamanan bersepeda ada di paragraf terakhir Teks B."
        }
      ]
    },
    {
      "id": "pi-berangkat-04",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “bugar” pada Teks A paling dekat maknanya dengan …",
      "pilihan": [
        {
          "teks": "Lelah dan lemas",
          "alasan": "Kebalikan dari bugar. Kalimat itu menyebut manfaat berjalan kaki, jadi artinya pasti hal yang baik bagi tubuh."
        },
        {
          "teks": "Sehat dan segar",
          "alasan": "Berjalan kaki setiap pagi adalah olahraga ringan yang membuat tubuh **sehat dan segar**. Jika diganti, kalimatnya tetap masuk akal: \"membuat tubuh lebih sehat dan segar\"."
        },
        {
          "teks": "Gemuk dan berat",
          "alasan": "Tidak sesuai. Teks tidak membahas berat badan, dan berjalan kaki tidak membuat tubuh gemuk."
        },
        {
          "teks": "Mengantuk",
          "alasan": "Tidak sesuai dengan kalimatnya. Berjalan kaki di pagi hari tidak disebut membuat tubuh mengantuk."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Selain itu, berjalan kaki setiap pagi membuat tubuh lebih bugar."
      ],
      "langkah": [
        {
          "teks": "Frasa **Selain itu** menunjukkan bahwa kalimat ini menambahkan **manfaat** lain dari berjalan kaki."
        },
        {
          "tanya": {
            "soal": "Kalimat tentang \"bugar\" membahas … berjalan kaki.",
            "pilihan": [
              "Manfaat",
              "Bahaya",
              "Biaya"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Karena itu manfaat, pilih arti yang baik bagi tubuh, yaitu **sehat dan segar**."
        }
      ]
    },
    {
      "id": "pi-berangkat-05",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa rem dan ban sepeda perlu diperiksa sebelum berangkat?",
      "pilihan": [
        {
          "teks": "Agar sepeda terlihat bersih dan baru",
          "alasan": "Teks tidak membahas kebersihan sepeda."
        },
        {
          "teks": "Agar perjalanan tidak memerlukan biaya",
          "alasan": "Biaya hanya dibahas di Teks A tentang berjalan kaki, dan tidak berhubungan dengan memeriksa rem."
        },
        {
          "teks": "Agar sepeda boleh melewati trotoar",
          "alasan": "Teks B tidak menyebut trotoar. Pengendara sepeda justru diminta berada di jalur sepeda atau sisi kiri jalan."
        },
        {
          "teks": "Agar tidak terjadi kecelakaan",
          "alasan": "Teks B: periksa dulu rem dan ban sepeda **agar tidak terjadi kecelakaan**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Sebelum berangkat, periksa dulu rem dan ban sepeda agar tidak terjadi kecelakaan."
      ],
      "langkah": [
        {
          "teks": "Cari kalimat tentang **rem dan ban** di Teks B. Kata **agar** di kalimat itu menunjukkan tujuan atau alasannya."
        }
      ]
    },
    {
      "id": "pi-berangkat-06",
      "bacaan": "pi-berangkat-sekolah",
      "topik": "sikap-refleksi",
      "tipe": "pg",
      "teks": "Rumah Dika agak jauh dari sekolah, dan ia memiliki sepeda. Berdasarkan kedua teks, pilihan yang paling tepat untuk Dika adalah …",
      "pilihan": [
        {
          "teks": "Berjalan kaki di tengah jalan agar cepat sampai",
          "alasan": "Rumahnya agak jauh, dan berjalan di tengah jalan berbahaya. Teks A menyarankan pejalan kaki berjalan di trotoar atau di tepi jalan."
        },
        {
          "teks": "Bersepeda tanpa memeriksa rem agar tidak terlambat",
          "alasan": "Bertentangan dengan Teks B yang meminta rem dan ban diperiksa agar tidak terjadi kecelakaan."
        },
        {
          "teks": "Bersepeda dengan memakai helm dan berada di sisi kiri jalan",
          "alasan": "Teks B menyebut bersepeda cocok untuk rumah yang agak jauh, dan menyarankan memakai helm serta bersepeda di jalur sepeda atau sisi kiri jalan."
        },
        {
          "teks": "Bersepeda di trotoar lalu menyeberang tanpa melihat kanan dan kiri",
          "alasan": "Teks B tidak menyarankan bersepeda di trotoar, dan Teks A meminta kita melihat ke kanan dan ke kiri sebelum menyeberang."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Bersepeda dapat menjadi pilihan bagi siswa yang rumahnya agak jauh dari sekolah.",
        "Pengendara sepeda juga sebaiknya memakai helm untuk melindungi kepala."
      ],
      "langkah": [
        {
          "teks": "Pertama, tentukan cara yang cocok untuk rumah yang **agak jauh**. Kedua, pilih cara yang juga mengikuti **saran keamanan** dari teks."
        },
        {
          "tanya": {
            "soal": "Menurut Teks B, bersepeda cocok untuk siswa yang rumahnya …",
            "pilihan": [
              "Dekat dengan sekolah",
              "Agak jauh dari sekolah"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Jadi Dika sebaiknya bersepeda, dengan tetap mengikuti saran keamanannya."
        }
      ]
    }
  ]
}
